export default __webpack_public_path__ + "static/media/marker_active.f7a0c447.svg";